import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import Style from './liveButton.less';
import './liveButton.less';

import Modal from '@tencent/dui/lib/components/Modal';
import Badge from '@tencent/dui/lib/components/Badge';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Menu from '@tencent/dui/lib/components/Menu';
import Divider from '@tencent/dui/lib/components/Divider';
import Dropdown from '@tencent/dui/lib/components/Dropdown';

import PPT_Dropdown from '../LiveBar/dropdown';
import LiveGuideDialog from '../LiveBar/dialog/live-guide-dialog';
import LiveInviteDialog from '../LiveBar/dialog/live-invite-dialog';
import { formatDate } from 'steamer-browserutils';
import { NoticeManager } from '../../../index'

import {
    LiveRoleType,
    LiveState,
    LiveStateChanged,
    ClientReady,
    LiveButtonEvent,
} from '../LiveConst';

const DISMISS_LIVE_BADGE = 'DISMISS_LIVE_BADGE';
export default class LiveButton extends Component {

    static propTypes = {
        enableLive: PropTypes.bool,
        liveDelegate: PropTypes.object,
        eventCallBack: PropTypes.func,
    };

    static defaultProps = {
        enableLive: false,
        liveDelegate: null,
        eventCallBack: (event, flag, data, extra) => {}, 
    }

    constructor(props) {
        super(props);
        this.state = {
            showLiveBtn: this.props.enableLive,
            hasShowRoom: false,
            audienceCount: 0,
            showBadge: false,
            showTestBtn: false,
        }
        this.liveManager = this.props.liveDelegate;
        this.hostname = (window.location && window.location.hostname) || 'docs.qq.com';
    }

    componentDidMount() {
        if (this.liveManager) {
            var dismissBadge = localStorage.getItem(DISMISS_LIVE_BADGE) || false;
            this.setState({
                showBadge: !dismissBadge,
            });
            this.liveManager.event.on(LiveStateChanged, (args)=>{
                console.log('LiveStateChanged:' + args);
                if (args && args[0] == LiveState.Pause || args[0] == LiveState.OnAir) {
                    this.setState({
                        hasShowRoom: true,
                    });
                }
                else {
                    this.setState({
                        hasShowRoom: false,
                    });
                }
            });
            if (this.props.enableLive) {
                this.liveManager.getShow();
            } 
        } else {
            this.setState({
                enableLive: false,
            });
        }
    }

    handleMenuVisibleChange = (visible) => {
        
    };

    handleCloseLiveGuideDialog = () => {
        this.dropDom.hide();
    };

    handleCloseLiveInviteDialog = (state) => {
        this.dropInvite.hide();
        switch (state.action) {
            case 'close':
                break;
            case 'play':
                this.onLiveStart();
                break;
            case 'end show':
                this.liveManager.closeShowRoom();
                break;
        }
    };

    /**
     * 点击开启直播
     */
    handleOpenDocLive = () => {
        this.liveManager.createShow((result) => {
            if (result.error) {
                Modal.confirm({
                    content: '信息未成功拉取，请刷新后重新发起远程演示。',
                    onOk: () => { window.location.reload() },
                    okText: '立即刷新',
                    cancelText: null
                });

            }
            else {
                this.liveManager.masterEnter();
                this.liveManager.event.on(ClientReady, () => {
                    this.showInvite();
                });
            }
            this.handleCloseLiveGuideDialog();
        });
    };

    /**
     * 显示邀请界面
     */
    showInvite = () => {
        this.dropInvite.show();
    };

    /**
     * 开始直播
     */
    onLiveStart = () => {
        this.props.eventCallBack(LiveButtonEvent.StartLiving);
    };

    onLocalPlay = () => {
        this.props.eventCallBack(LiveButtonEvent.StartLocalPlay);
    }

    onCopyLink = (url) => {
        this.props.eventCallBack(LiveButtonEvent.CopyLink, true, url);
    }

    onFlipChanged = (value) => {
        if (this.liveManager) {
            this.liveManager.setAllowFlip(value);
            this.props.eventCallBack(LiveButtonEvent.AudienceFlip, value);   
        }
    }
 
    handleInviteDropVisibleChange = (visible) => {

    };

    waitingInfo = ()=>{
        if (this.liveManager && this.liveManager.role === LiveRoleType.Master) {
            let audienceCount = this.state.audienceCount;
            if (audienceCount > 0) {
                return `${audienceCount}人正在等待观看`;
            }
        }
        return '等待收看者加入';
    };

    onPlayMenuClicked = (id) => {
        switch(id){
            case 'live':
                this.onLiveStart();
                break;
            case 'play':
                this.onLocalPlay();
                break;
            default:
        }
    };

    onLiveShowClicked = () => {
        this.onHideBadge();
        this.props.eventCallBack(LiveButtonEvent.LiveButtonClicked, true);
    };

    onHideBadge = () => {
        let dismissBadge = localStorage.getItem(DISMISS_LIVE_BADGE) || false;
        if (dismissBadge) {
            return;
        }
        localStorage.setItem(DISMISS_LIVE_BADGE, true);
        this.setState({
            showBadge: false,
        });
    }

    onPlayMemuVisibleChanged = (v) => {
        if (v) {
            if (this.liveManager && this.liveManager.role === LiveRoleType.Master) {
                let memberCount = this.liveManager.memberCount;
                let audienceCount = memberCount > 0 ? memberCount - 1 : 0;
                this.setState({
                    audienceCount: audienceCount,
                });
            }
        }
    };
    initNoticeManager(duration=30*60, maxCount=10) {
        //默认显示时长30分钟，最多显示10个
        NoticeManager.getInstance().duration = duration ;
        NoticeManager.getInstance().maxCount = maxCount;
    }
    getLivePush() {
        let liveManager = this.liveManager;
        let docId = this.liveManager.docID;

        liveManager.getAllShow().then(response => {
            console.log(response);
            if (response.data
                && response.data.hasOwnProperty('retcode')
                && 0 === response.data.retcode
                && response.data.result
                && response.data.result.room_list
            ) {
                let room_list = response.data.result.room_list;
                for (let i = 0; i < room_list.length; i++) {
                    let room = room_list[i];
                    console.log('NoticeManager Check room:', room);
                    let { name, roomid, start_time, state, uid } = room;
                    if (!roomid) { continue; }
                    if (state !== LiveState.OnAir) { continue; }
                    if (uid && uid === this.liveManager.TOID) { continue; }
                    let time = new Date(start_time);
                    // 只显示30分钟之内的通知
                    if (time && new Date().getTime() - start_time < 30 * 60 * 1000) {
                        console.log('NoticeManager Prepare Image room:', room);
                        // 获取头像信息之后再通知
                        this.liveManager.getUserInfo(uid, userInfo => {
                            let { userPic } = userInfo;
                            let notice = {
                                name,
                                startTime: formatDate(time, 'HH:mm'),
                                startTimeValue: time,
                                url: `https://${this.hostname}/meeting/${docId}?id=${roomid}`,
                                userPic,
                            };
                            NoticeManager.getInstance().append(notice);
                            console.log('NoticeManager show notice:', notice);
                        });
                    }
                }
            }
        });

    }
    // 收到LiveMessage消息后，弹出远程播放通知
    onLivePush(data) {
        if (data && data.head && data.head.type === 'LIVE_MESSAGE' && data.body && data.body.docid) { // 校验Head合法性
            let docId = data.body.docid;
            let { ownerid, roomid } = data.head;
            let time = new Date(); // 收到消息的时间就是开始时间
            let url = `https://${this.hostname}/meeting/${docId}?id=${roomid}`;
            let { name, state } = data.body.room_info || {};
            let userPic = '';
            let notice = {
                name,
                startTime: formatDate(time, 'HH:mm'),
                startTimeValue: time,
                url,
                userPic
            }
            let liveManager = this.liveManager;
            if (data.body.type === 'STATE') {
                // 正常退出演示
                // console.log(liveManager.TOID, liveManager.roomInfo(), data.head);
                if (liveManager.roomInfo().roomid === roomid) {
                    // 不显示自己
                    return;
                }

                if (state === LiveState.OnAir) {
                    // 获取头像信息之后再通知
                    liveManager.getUserInfo(ownerid, userInfo => {
                        if (userInfo) {
                            let { userPic } = userInfo;
                            notice.userPic = userPic;
                        }
                        NoticeManager.getInstance().append(notice);
                    });
                } else {
                    NoticeManager.getInstance().onCloseNotice(notice);
                }
            }
            else if (data.body.hasOwnProperty('data') && data.body.data.length === 0) {
                // 异常退出演示
                console.info(name + ' exit live', notice);
                NoticeManager.getInstance().onCloseNotice(notice);
            }
        }
    }
    onLiveTestClicked = () => {
        let tenMin = 10 * 60 * 1000;
        NoticeManager.getInstance().duration = 30 * 60 * 1000;

        let nnn = [];
        for (let i = 10; i > 0; i--) {
            let time = new Date() - i * tenMin;
            let n = {
                name: `${i}0分钟前四川人`,
                startTime: formatDate(time, 'HH:mm'),
                startTimeValue: time,
                url: `https://${this.hostname}/meeting/` + Math.random(),
                userPic: 'https://thirdqq.qlogo.cn/g?b=oidb&k=uhfiaKrM2gcUUm8IqjF0iaAg&s=0',
            }
            nnn.push(n);
        }
        nnn.push({
            name: '现在123',
            startTime: formatDate(new Date(), 'HH:mm'),
            startTimeValue: new Date(),
            url: `https://${this.hostname}/meeting/1`,
            userPic: ''
        });

        NoticeManager.getInstance().append(nnn);
    }
    showTestButton(show) {
        this.setState({
            showTestBtn: show,
        })
    }
    render() {
        let square = { width: '38px',};
        let hasShowRoom = this.state.hasShowRoom;
        let waiting = this.waitingInfo();

        let BasicMenu = (
            <div className={'playButtonDropdown ' + Style.playButtonDropdown}>
                <Menu onClick={this.onPlayMenuClicked}>
                    <Menu.Item id="live" className={'menuLiveItem ' + Style.menuLiveItem}>
                        <div className={'playMenuContent ' + Style.playMenuContent}>
                            <div className={'menuText ' + Style.menuText}>在远程演示上播放</div>
                            <div className={'menuTip ' + Style.menuTip}>{waiting}</div>
                        </div>
                    </Menu.Item>
                    <Divider className={'menuLiveDivider ' + Style.menuLiveDivider} />
                    <Menu.Item id="play" className={'menuLiveItem ' + Style.menuLiveItem}>
                        <div className={'playMenuContent ' + Style.playMenuContent}>
                            <div className={'menuText ' + Style.menuText}>仅在这台电脑播放</div>
                        </div>
                    </Menu.Item>
                </Menu>
            </div>
        );
        
        return (
            <div className={'playButtonWrapper ' + Style.playButtonWrapper}>
                <Tooltip placement="bottom" title={'开始播放'}>
                    { 
                        this.state.showLiveBtn && hasShowRoom ?
                            <Dropdown dropContent={BasicMenu} alignment="right" 
                            // onVisibleChange={this.onPlayMemuVisibleChanged} 
                            >
                                <button className={'play-auth-btn ' + Style['play-auth-btn'] + ' play-btn-normal ' + Style['play-btn-normal']} style={square}>
                                    <div className={'image ' + Style.image + ' play-ic ' + Style['play-ic']}></div>
                                </button>
                            </Dropdown> 
                            :
                            <button className={'play-auth-btn ' + Style['play-auth-btn'] + ' play-btn-normal ' + Style['play-btn-normal']} style={square} onClick={this.onLocalPlay}>
                                <div className={'image ' + Style.image + ' play-ic ' + Style['play-ic']}></div>
                            </button>
                    }
                </Tooltip>
                {
                    this.state.showLiveBtn ?
                        <Tooltip placement="bottom" title={'远程演示'}>
                            {
                                !hasShowRoom ?
                                    <Badge 
                                        dot={this.state.showBadge}
                                        offsetX={-9}
                                        offsetY={0}
                                    >
                                        <button id="live-show-btn-play" 
                                            className={'play-auth-btn ' + Style['play-auth-btn'] + ' play-btn-normal ' + Style['play-btn-normal']} 
                                            style={square}
                                            onClick={this.onLiveShowClicked}
                                        >
                                            <div className={'image ' + Style.image + ' live-ic ' + Style['live-ic']}></div>
                                        </button>
                                    </Badge>
                                    :
                                    <button id="live-invite-btn-play" 
                                        className={'play-auth-btn ' + Style['play-auth-btn'] + ' play-btn-normal ' + Style['play-btn-normal']} 
                                        style={square}
                                        onClick={this.onHideBadge}
                                        ref={(el) => { this.divRefs = el }}
                                    >
                                        <div className={'image ' + Style.image + ' live-ready-ic ' + Style['live-ready-ic']}></div>
                                    </button>
                            }
                        </Tooltip>
                        : null
                }
                {
                    this.state.showTestBtn && <button id="live-test-btn"
                        className={'play-auth-btn ' + Style['play-auth-btn'] + ' play-btn-normal ' + Style['play-btn-normal']} 
                        style={square}
                        onClick={this.onLiveTestClicked}
                    >
                        <div className={Style.image + ' ' + Style['live-ic']}></div>
                    </button>
                }

                <PPT_Dropdown belongID={'live-show-btn-play'} ref={ref => { this.dropDom = ref }}
                    onVisibleChange={this.handleMenuVisibleChange} scrollable={false}
                    center="center"
                    hasShadow={false}
                    offsetX={0}
                    offsetY={5}
                    isTransparent={true}
                >
                    <LiveGuideDialog
                        showArrow={true}
                        darkMode={false}
                        handleOpenDocLive={this.handleOpenDocLive}
                        handleCloseLiveGuideDialog={this.handleCloseLiveGuideDialog}
                        {...this.state}></LiveGuideDialog>
                </PPT_Dropdown>

                <PPT_Dropdown belongID={'live-invite-btn-play'} ref={ref => { this.dropInvite = ref }}
                    onVisibleChange={this.handleInviteDropVisibleChange} scrollable={false}
                    center="center"
                    hasShadow={false}
                    offsetX={0}
                    offsetY={5}
                    isTransparent={true}
                >
                    <Suspense fallback={<div></div>}>
                        <LiveInviteDialog
                            darkMode={false}
                            handleOpenDocLive={this.handleOpenDocLive}
                            handleCloseDialog={this.handleCloseLiveInviteDialog}
                            hidePlay={!this.props.enableLive}
                            hideClose={false}
                            hideAllowFlip={false}
                            showArrow={true}
                            liveDelegate={this.liveManager}
                            onCopyLink={this.onCopyLink}
                            onFlipChanged={this.onFlipChanged}
                            {...this.state}></LiveInviteDialog>
                    </Suspense>
                </PPT_Dropdown>
            </div>
        );
    }
}